<template src="./template.html"></template>
<script>
import { mapState } from 'vuex'

import BOOKING_PAYMENT_TYPES from 'constants/bookingPaymentTypes'
import PAYMENT_TYPES from 'constants/paymentTypes'
import INVENTORY_TYPES from 'constants/inventoryTypes'
import VENUE_TYPES from 'constants/venueTypes'

export default {
  name: 'checkout-summary',
  props: {
    hideVenueInfo: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      PAYMENT_TYPES,
      BOOKING_PAYMENT_TYPES,
      INVENTORY_TYPES,
    }
  },
  computed: {
    ...mapState({
      loggedIn: (state) => state.auth.loggedIn,
      user: (state) => state.user.current,
      venue: (state) => state.venue.current,
      booking: (state) => state.checkout.booking,
      items: (state) => state.checkout.items,
      paymentType: (state) => state.checkout.paymentType,
    }),
    purchaseComplete() {
      if (!this.booking) return false

      return this.booking.status === 'COMPLETE'
    },
    showItemDescriptions() {
      return !this.isDispensary
    },
    showPaymentBreakdown() {
      return !(this.isDispensary && this.booking.items && this.booking.items.length && this.booking.items[0].type === INVENTORY_TYPES.PICK_UP_TIME)
    },
    subtotalText() {
      if (this.isDispensary) {
        return 'Total'
      }

      if (this.booking.payment === BOOKING_PAYMENT_TYPES.VENUE) return 'Min due at the venue'
      if (this.booking.payment === BOOKING_PAYMENT_TYPES.ADVANCE || this.booking.payment === BOOKING_PAYMENT_TYPES.ADVANCE_DEPOSIT) return 'Total'

      return 'Total'
    },
    isDispensary() {
      if (!this.venue) return false

      return this.venue.type === VENUE_TYPES.DISPENSARY
    },
  },
  methods: {},
}
</script>



// WEBPACK FOOTER //
// src/components/CheckoutSummary/index.vue